/* ========================================================================== 
   3D ADAPTER -> SHARED SFFLABS PORTABLE BUILD CONTRACT
   The codec/schema lives in /assets/shared/sff-contract.js. This file retains
   the Workbench's historical exports so the rest of 3D does not own a copy.
   ========================================================================== */
import '/assets/shared/sff-contract.js?v=20260822-statebridge4';

const Contract = () => window.SFFContracts;

export const SFF_BUILD_SCHEMA = Contract()?.BUILD_SCHEMA || 2;
export const SFF_IDENTITY_SCHEMA = Contract()?.IDENTITY_SCHEMA || 1;

export function normalizeSffBuildPayload(raw) {
  return Contract()?.normalizeBuildPayload?.(raw) || null;
}

export function encodeSffBuildToken(payload) {
  return Contract()?.encodeBuildToken?.(payload) || '';
}

export function decodeSffBuildToken(token) {
  return Contract()?.decodeBuildToken?.(token) || null;
}

export function parse3dBuildRoute(pathname = location.pathname) {
  return Contract()?.parse3dRoute?.(pathname) || { slug: null, stateToken: null };
}

export function databaseBridgePath(caseRecordOrSlug, payload) {
  return Contract()?.dbCasePath?.(caseRecordOrSlug, payload) || '/db/build/';
}
